import React from "react";
import GuideMultiInputRenderer from "./components/GuideMultiInputRenderer";

export function GuideMultiInput(base) {
  return {
    getConfig() {
      return {
        name: "GuideMultiInput",
        displayName: IdealStudio.i18n.t("GuideMultiInput.PluginName") || "Multi-Input",
        category: "objects",
        needsConfigModal: false,
        needsTextEdition: false,
        flavor: "react",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        icon: "playlist_add_check",
        allowFloatingBox: true,
        notResizable: true,
        fullScreenOverlay: true,
      };
    },
    getToolbar(state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            info: {
              __name: IdealStudio.i18n.t("GuideMultiInput.Items") || "Items",
              icon: "playlist_add_check",
              buttons: {
                itemCount: {
                  __name: IdealStudio.i18n.t("GuideMultiInput.ItemCount") || "Item Count",
                  type: "text",
                  value: String((state.items || []).length),
                  readOnly: true,
                },
              },
            },
          },
        },
      };
    },
    getRenderTemplate(state, props) {
      return (
        <GuideMultiInputRenderer
          items={state.items || []}
          visor={!!props?.visor}
          advanceOnComplete={state.advanceOnComplete !== false}
          guidedCue={state.guidedCue}
          zoomEnabled={state.zoomEnabled === true}
          onAdvance={props?.onAdvance}
          onNavigate={props?.onNavigate}
          setTag={props?.setTag}
          tagValues={props?.tagValues}
          onItemsUpdate={(items) => {
            if (props && typeof props.update === "function") {
              props.update("items", items);
            }
          }}
        />
      );
    },
  };
}
